import React, { useCallback, useEffect, useState } from "react";
import baseUrl from "../../../../api/baseUrl";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import MedicalInformationIcon from "@mui/icons-material/MedicalInformation";
import socket from "../../../../api/socket";

const statusStyles: Record<string, string> = {
  ongoing: "bg-lime-100 dark:bg-lime-900/40 text-lime-700 dark:text-lime-300 border-lime-300 dark:border-lime-600",
  inqueue: "bg-sky-100 dark:bg-sky-900/40 text-sky-700 dark:text-sky-300 border-sky-300 dark:border-sky-600",
  canceled: "bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300 border-red-300 dark:border-red-600",
  completed: "bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 border-emerald-300 dark:border-emerald-600",
  appointment: "bg-orange-100 dark:bg-orange-900/40 text-orange-700 dark:text-orange-300 border-orange-300 dark:border-orange-600",
  reschudle: "bg-cyan-100 dark:bg-cyan-900/40 text-cyan-700 dark:text-cyan-300 border-cyan-300 dark:border-cyan-600",
  noshow: "bg-slate-100 dark:bg-slate-600 text-slate-700 dark:text-slate-200 border-slate-300 dark:border-slate-500",
  default: "bg-white dark:bg-slate-700 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-600",
};

function AppointmentTr({ item, appointmStatus }: any) {
  const [select, setselect] = useState(item?.status);
  const navigate = useNavigate();

  useEffect(() => {
    setselect(item?.status);
  }, [item]);

  const handleChange = (e: any) => {
    setselect(e.target.value);
    socket.emit("allAppointmentStatus", {
      appointmentid: item?._id,
      status: e.target.value,
    });
    baseUrl
      .patch(
        "/appointment/statusAppointmentById",
        {},
        {
          headers: { appointmentid: item?._id, status: e.target.value },
        }
      )
      .then(() => appointmStatus())
      .catch((error) => console.log(error));
  };

  const handleTreatmentClick = useCallback(
    (id: string, e: React.MouseEvent) => {
      e.stopPropagation();
      baseUrl
        .post("treatment/create-treatment", { patientId: id })
        .then((response) => {
          navigate(
            `/client/treatment-diagnose/add-treatment/diagnose/${response.data.data._id}`
          );
        })
        .catch((error) => console.error(error));
    },
    [navigate]
  );

  const handleClickGoViewPatient = useCallback(
    (id: string) => navigate(`/client/patients/patientone/general-detail/${id}`),
    [navigate]
  );

  return (
    <tr className="hover:bg-slate-50/50 dark:hover:bg-slate-700/50 transition-colors group">
      <td className="px-6 py-3 text-sm font-semibold text-slate-900 dark:text-slate-100">
        {item?.patientId?.fullName ? item?.patientId?.fullName : item?.bookPatientId?.fullName || "N/A"}
      </td>
      <td className="px-6 py-3 whitespace-nowrap text-sm text-slate-600 dark:text-slate-300">
        {item?.date?.split("T")[0]}
      </td>
      <td className="px-6 py-3">
        <span className="px-2.5 py-1 bg-primary/10 dark:bg-primary/30 text-primary dark:text-sky-300 rounded-md text-xs font-medium">
          {item?.startTime} - {item?.endTime}
        </span>
      </td>
      <td className="px-6 py-3">
        <select
          onChange={handleChange}
          value={select}
          className={`px-3 py-1.5 rounded-lg text-sm font-medium border cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary/20 transition-colors ${
            statusStyles[select] || statusStyles.default
          }`}
        >
          <option value="">Select</option>
          <option value="appointment">Upcoming</option>
          <option value="completed">Completed</option>
          <option value="canceled">Canceled</option>
          <option value="inqueue">In Queue</option>
          <option value="ongoing">Ongoing</option>
          <option value="noshow">No Show</option>
        </select>
      </td>
      <td className="px-6 py-3 text-sm text-slate-700 dark:text-slate-200">
        {item?.purposeId?.purposeName || item?.bookTreatmentId?.name || "N/A"}
      </td>
      <td className="px-6 py-3">
        <span className={`px-2.5 py-1 rounded-md text-xs font-medium capitalize ${
          item?.type === "online" ? "bg-primary/10 dark:bg-primary/30 text-primary" : "bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300"
        }`}>
          {item?.type || "N/A"}
        </span>
      </td>
      <td className="px-6 py-3">
        <div className="flex gap-2 justify-center">
          {item?.patientId?.fullName ? (
            <>
              <button
                onClick={() => handleClickGoViewPatient(item?.patientId?._id)}
                className="w-8 h-8 rounded-lg bg-indigo-50 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 flex items-center justify-center hover:bg-indigo-100 dark:hover:bg-indigo-900/60 active:bg-indigo-200 transition-all focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1 opacity-100"
                title="View Patient"
                aria-label="View Patient"
              >
                <RemoveRedEyeIcon sx={{ fontSize: 18 }} />
              </button>
              <button
                onClick={(e: any) => handleTreatmentClick(item?.patientId?._id, e)}
                className="w-8 h-8 rounded-lg bg-emerald-50 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-300 flex items-center justify-center hover:bg-emerald-100 dark:hover:bg-emerald-900/60 active:bg-emerald-200 transition-all focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-1 opacity-100"
                title="Add Treatment"
                aria-label="Add Treatment"
              >
                <MedicalInformationIcon sx={{ fontSize: 18 }} />
              </button>
            </>
          ) : (
            <span className="text-xs text-slate-400 dark:text-slate-500 italic">Patient not added</span>
          )}
        </div>
      </td>
    </tr>
  );
}

export default AppointmentTr;
